// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"e0b77cbf","846":"78f1dd0d"}[chunkId] + ".chunk.css";
};